import { jsx as o } from "react/jsx-runtime";
import { SearchCard as u, APointRedeemCard as s } from "@commerce-product-webcomponents/ui";
import { ProductMerchandise as h } from "@commerce-product-webcomponents/ui-composite";
import { CarousalType as r } from "./components/ProductCarousal/types/propsType.js";
import './assets/CarousalItem.css';const p = "#ffffff", g = "#396e75", m = "#e5fdff", _ = "#546223", C = "#f0fae5", V = "#a65523", z = "#fff1e8", f = "#7f3e3e", k = "#ffe2e2", y = "#62625a", b = "#f8f8e7", O = "#38539a", B = "#707070", w = "#c8f8d1", P = "#87c9c8", G = "#5291b1", A = "rgba(82, 145, 177, 0.1019607843)", R = "#445685", S = "#181d61", W = "rgba(24, 29, 97, 0.1019607843)", v = "#5969d6", I = "#ea999d", T = "#b6577e", D = "rgba(182, 87, 126, 0.1019607843)", N = "#7e3e80", j = "#1e247f", Y = "rgba(30, 36, 127, 0.1019607843)", x = "#da7600", E = "#107f47", F = "#d91734", H = "_html_10yth_75", K = {
  amwayWhite: p,
  darkBlue: g,
  lightBlue: m,
  darkGreen: _,
  lightGreen: C,
  darkOrange: V,
  lightOrange: z,
  darkRed: f,
  lightRed: k,
  darkYellow: y,
  lightYellow: b,
  darkPurple: O,
  darkGrayOnWhite: B,
  dataVizColor1: w,
  dataVizColor2: P,
  dataVizColor3: G,
  dataVizColor3Background: A,
  dataVizColor4: R,
  dataVizColor5: S,
  dataVizColor5Background: W,
  dataVizColor6: v,
  dataVizColor7: I,
  dataVizColor8: T,
  dataVizColor8Background: D,
  dataVizColor9: N,
  dataVizColor10: j,
  dataVizColor10Background: Y,
  dataVizAlertOrange: x,
  dataVizSuccessGreen: E,
  dataVizWarningRed: F,
  "no-visible": "_no-visible_10yth_34",
  html: H,
  "container-background-color-light_purple": "_container-background-color-light_purple_10yth_142",
  "product-card": "_product-card_10yth_146",
  "carousel-product-item": "_carousel-product-item_10yth_150",
  "product-carousal-container": "_product-carousal-container_10yth_154",
  "theme-blue": "_theme-blue_10yth_158",
  "theme-green": "_theme-green_10yth_162",
  "theme-orange": "_theme-orange_10yth_166",
  "theme-red": "_theme-red_10yth_170",
  "theme-purple": "_theme-purple_10yth_174",
  "product-carousal-title": "_product-carousal-title_10yth_178",
  "product-carousal-timer": "_product-carousal-timer_10yth_187"
}, J = (a) => {
  const {
    productItem: t,
    showProductIdAndSizeComp: d = !0,
    showVariantComp: n = !0,
    showAddToCartButtonComp: l = !0,
    showAddToWishlistComp: c = !0
  } = a, e = {
    productId: t.productId,
    link: t.mainLink ?? "",
    alt: t.alt,
    brandName: t.brandName ?? "",
    productName: t.productName,
    productSize: t.productSize,
    productPrice: t.productPrice,
    pointValue: t.pointValue,
    businessVolume: t.businessVolume,
    variantGroupData: t.variantData
  }, i = () => a.type === r.Horizontal ? /* @__PURE__ */ o(
    h,
    {
      productData: t,
      strikethroughPrice: 40,
      maxCount: 20,
      disabled: !1,
      showRightIcon: !1,
      entryObj: e
    }
  ) : a.type === r.Vertical ? /* @__PURE__ */ o(
    u,
    {
      productData: t,
      disabled: !1,
      className: K["product-card"],
      entryObj: e,
      showProductIdAndSizeComp: d,
      showVariantComp: n,
      showAddToCartButtonComp: l,
      showAddToWishlistComp: c
    }
  ) : a.type === r.APointCatalog ? /* @__PURE__ */ o(s, { productData: t }) : null;
  return t && Object.keys(t).length > 1 && t.derivedAvailabilityStatus !== "OUT_OF_STOCK" ? i() : null;
};
export {
  J as C,
  K as s
};
//# sourceMappingURL=CarousalItem-0f9f40b6.mjs.map
